import { SENTENCE_REGEX } from '@service/text-buffer';

const splitTextToSentences = (text: string, maxLength: number): string[] => {
  const sentences: string[] = [];
  let currentSentence = "";

  const addSentence = (sentence: string) => {
    while (sentence.length > maxLength) {
      let splitIndex = sentence.lastIndexOf(" ", maxLength);
      if (splitIndex === -1) {
        splitIndex = maxLength; // If no space found, split at maxLength
      }
      sentences.push(sentence.slice(0, splitIndex));
      sentence = sentence.slice(splitIndex).trim();
    }
    if (sentence) {
      sentences.push(sentence);
    }
  };

  text.split(SENTENCE_REGEX).forEach((sentence) => {
    if ((currentSentence + sentence).length <= maxLength) {
      currentSentence += (currentSentence ? " " : "") + sentence;
    } else {
      if (currentSentence) {
        addSentence(currentSentence);
      }
      currentSentence = sentence;
    }
  });

  if (currentSentence) {
    addSentence(currentSentence);
  }

  return sentences;
};

export default splitTextToSentences;
